import { render, staticRenderFns } from "./messageManage.vue?vue&type=template&id=0caa3c5d&"
import script from "./messageManage.vue?vue&type=script&lang=js&"
export * from "./messageManage.vue?vue&type=script&lang=js&"
import style0 from "./messageManage.vue?vue&type=style&index=0&id=0caa3c5d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports